module.exports = [{"key":"1","name":"请假流程我的方案","icon":"","editTime":"2017-11-11","canEdit":false,"type":"流程","where1":"政府"},{"key":"2","name":"请假流程我的方案","icon":"","editTime":"2017-11-11","canEdit":false,"type":"门户","where1":"软件"},{"key":"3","name":"请假流程我的方案","icon":"","editTime":"2017-11-11","canEdit":false,"type":"定制","where1":"物流"}]


//////////////////
// WEBPACK FOOTER
// ./src/mocks/scheme/datas_scheme_app.json
// module id = 340
// module chunks = 0